/*
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

export enum ConfirmationEvent {
  confirmationNoPatientEducation = 'confirmationNoPatientEducation',
  confirmationPatientEducationShort = 'confirmationPatientEducationShort',
  confirmationPatientEducationLong = 'confirmationPatientEducationLong',
  confirmationRefusalMedicalTreatment = 'confirmationRefusalMedicalTreatment',
  confirmationRefusalTransport = 'confirmationRefusalTransport',
}

export type ConfirmationDetails = {
  [label in ConfirmationEvent]: {
    title: string;
    text: string;
  };
};
